// extracted by mini-css-extract-plugin
export default {"description":"style_description__bmJ58","fade-in":"style_fade-in__aw+IR","top":"style_top__RIP1u","image":"style_image__lmFcz"};